const carouselItems = [
  {
    id: 1,
    tag: '院线热映',
    title: '2026暑期档最全观影指南',
    desc: '盘点今年暑期档最值得期待的十部大片，从动作巨制到温情动画，一篇带你了解全部亮点，不踩雷选片就看这篇。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20with%20warm%20summer%20golden%20hour%20lighting%2C%20movie%20theater%20vibe%2C%20soft%20atmospheric%20glow%2C%20film%20cinema%20aesthetic%2C%20elegant%20composition%2C%20no%20text%20no%20people&width=800&height=400&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    tag: '经典重温',
    title: '豆瓣TOP250必看经典盘点',
    desc: '那些年我们追过的神作，高清修复版重新上线。每一部都是影史经典，值得反复品味的光影记忆。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20cinematic%20wide%20banner%20with%20sepia%20and%20warm%20amber%20tones%2C%20classic%20film%20nostalgic%20aesthetic%2C%20soft%20texture%2C%20old%20hollywood%20atmosphere%2C%20elegant%20composition%2C%20no%20text%20no%20people&width=800&height=400&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    tag: '深度解析',
    title: '科幻电影中的未来预言',
    desc: '从《星际穿越》到《沙丘》，那些曾经只存在于科幻电影中的黑科技，如今有多少已经变为现实？',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20cinematic%20wide%20banner%20with%20cool%20metallic%20and%20deep%20space%20tones%2C%20sci%20fi%20film%20aesthetic%2C%20abstract%20digital%20landscape%2C%20clean%20minimal%20composition%2C%20professional%20movie%20look%2C%20no%20text%20no%20people&width=800&height=400&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    tag: '新片速递',
    title: '八月最受期待新片前瞻',
    desc: '动作、悬疑、动画全面开花，八月院线新片阵容豪华，哪一部会成为票房黑马？抢先了解新片看点。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20wide%20banner%20with%20crimson%20and%20deep%20red%20spotlight%20tones%2C%20movie%20premiere%20atmosphere%2C%20theatrical%20lighting%2C%20elegant%20minimalist%20composition%2C%20film%20festival%20aesthetic%2C%20no%20text%20no%20people&width=800&height=400&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-500">精选深度内容，带你发现更多好电影</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer hover:border-accent-300/60 transition-all duration-300"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}